import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Your personal stats
  const githubStats = {
    contributions: 50,
    repositories: 38,
    followers: 20,
    stars: 4
  };

  const communityStats = {
    members: 100,
    mentees: 234,
    projects: 120,
    countries: 5
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="bg-[#0D1317] text-[#F0F0F0] relative min-h-screen pt-24 pb-12 overflow-hidden flex items-center">
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"> {/* Added py-8 for better vertical spacing */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Content Side */}
          <div className={`space-y-6 text-center lg:text-left transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold text-[#F0F0F0] leading-tight font-display">
              Adrian. Developer, Tutor, and Tech Innovator
            </h1>
            <p className="text-md sm:text-xl text-gray-400 font-body max-w-xl mx-auto lg:mx-0 pt-2">
              Building impactful solutions and empowering the next generation of tech leaders.
            </p>

            {/* CTA Button */}
            <div className="pt-4 flex justify-center lg:justify-start">
              <Link to="/contactpage">
                <Button
                  variant="default"
                  size="lg"
                  iconName="ArrowRight"
                  iconPosition="right"
                  iconSize={20}
                  className="bg-[#FFD700] text-[#0D1317] hover:bg-yellow-400 shadow-xl rounded-lg px-6 py-3 text-lg font-bold"
                >
                  Schedule Your Call With Us
                </Button>
              </Link>
            </div>

            {/* Stats Section */}
            <div className="pt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-6 sm:gap-8">
              <div className="flex items-center space-x-2">
                <Icon name="Github" size={24} className="text-[#FFD700]" />
                <span className="font-semibold text-[#F0F0F0] text-sm sm:text-base">{githubStats.contributions}+ Contributions</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={24} className="text-[#FFD700]" />
                <span className="font-semibold text-[#F0F0F0] text-sm sm:text-base">{communityStats.members}+ Community Members</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Trophy" size={24} className="text-[#FFD700]" />
                <span className="font-semibold text-[#F0F0F0] text-sm sm:text-base">{communityStats.mentees}+ Mentees</span>
              </div>
            </div>
          </div>

          {/* Right Visual Side - Image with subtle background */}
          <div className="relative flex items-center justify-center h-full min-h-[300px] sm:min-h-[400px] lg:min-h-[600px] pt-12 lg:pt-0"> {/* Adjusted min-h for better mobile scaling */}
            {/* Darker blue background behind the image */}
            <div className="absolute inset-0 bg-[#0D1317] opacity-80 rounded-xl"></div> {/* Changed to rounded-xl */}
            
            {/* Your 'me.png' image with the added brightness filter, border radius, and gold border */}
            <img 
              src="/me.png"
               alt="Professional headshot of Ebesoh Adrian, Developer, Tutor, and Tech Innovator"
              className="relative z-10 w-full h-full object-cover object-center-top border-2 border-[#FFD700] rounded-xl"
              style={{ filter: 'brightness(1.1)' }}
            />
          </div>
        </div>
      </div>

      {/* "Where Vision Becomes Reality" Section */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 lg:bottom-12 lg:left-auto lg:right-8 z-20 p-4 md:p-6 w-[calc(100%-2rem)] sm:w-2/3 lg:w-1/3 max-w-sm text-[#F0F0F0] bg-[#0D1317] shadow-lg rounded-xl"> {/* Adjusted width, padding, and rounded-xl */}
        <h3 className="text-lg md:text-xl font-bold mb-2 font-display">Where Vision Becomes Reality</h3> {/* Adjusted font size */}
        <p className="text-gray-400 mb-4 font-body text-xs md:text-sm"> {/* Adjusted font size */}
          We don’t follow trends – we create them. Building trusted tech for real human impact.
        </p>
        <a href="/aboutpage" className="flex items-center text-[#FFD700] font-semibold hover:underline text-sm md:text-base">
          Learn More <Icon name="ArrowRight" size={16} className="ml-2" />
        </a>
      </div>
    </section>
  );
};

export default HeroSection;